__turbopack_context__.v({
  "root": "styles-module__3y_Weq__root",
});
